import { Type } from "class-transformer";
import { CalendarEventKind } from "./CalendarEventKind";
import { CalendarEvent } from "./CalendarEvent";

export class EventReminderInfo {
    //netgen start
    eventId = 0;
    eventTitle: string;
    eventKind: CalendarEventKind = CalendarEventKind.appointment;
    @Type(() => Date)
    eventStartDate: Date;
    //netgen end

    event: CalendarEvent;
}
